import React,{useState} from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { useTranslation } from 'react-i18next';
import SelectAddress from './reduxFormComponents/SelectAddress'


export const SelctAppointmentLocaitonRedux = ({
   input,disabled,isSeriveAtClinicToo
})=>{
  const [selectedTab, setSelectedTab] = useState(input.value?1:0)
    const { t } = useTranslation();
    const handleChange = (event, newValue) => {
      setSelectedTab(newValue);
      input.onChange(null)
      };
   return <Box pb={2}>
   {isSeriveAtClinicToo && <>
   <Tabs value={selectedTab} onChange={handleChange} variant="fullWidth" centered indicatorColor="primary"
    textColor="primary">
   <Tab label={t('service_at_clinic')} />
   <Tab label={t('service_at_home')}  />
 </Tabs>
 </>}
<TabPanel value={isSeriveAtClinicToo ? selectedTab : 1 } index={1}>
<SelectAddress input={input} hideCheckbox disabled={disabled}/>
{/* {(customerAddress && !isLocationValid) ? <Box pt={1}><Alert severity="error">{t('supplier_doesnt_reach_location')}</Alert></Box>:<></>} */}
</TabPanel>
</Box>
}


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box pt={2}>
          {children}
        </Box>
      )}
    </div>
  );
}